import React from 'react';
import { useTaggingConfig } from 'src/ItemTags/api';
import { notStarted } from 'ocfe/src/utils/loadable';

export type TaggingConfig = {
    validTagGroupsExist: boolean;
    showTagGroupLabels: boolean;
    userCreatedTagGroupName: string;
};

type TaggingConfigLoadableValue = ReturnType<typeof useTaggingConfig>;

const TaggingContext = React.createContext<TaggingConfigLoadableValue>([notStarted(), () => {}]);
TaggingContext.displayName = 'TaggingContext';
export { TaggingContext };
